<template>
  <v-container fluid class="px-8">
    <v-row>
      <v-col cols="3">
        <div class="avatar-wrapper">
          <div class="upload-button" @click="clickInputUpload">
            <img
              class="profile-pic"
              @click="clickInputUpload"
              :src="getImage(this.form.image)"
              v-if="this.form.image"
            />
            <i class="fas fa-camera"></i>
          </div>
          <input
            class="file-upload"
            @change="setFile($event.target.files)"
            ref="fileUpload"
            type="file"
            accept="image/*"
          />
        </div>
      </v-col>
      <v-col cols="6" offset="1">
        <v-row>
          <v-col cols="12">
            <p class="label">Title</p>
            <v-text-field
              outlined
              hide-details="auto"
              v-model="form.title"
              required
              class="mb-4"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <p class="label">Date</p>
            <v-menu
              offset-y
              max-width="290px"
              min-width="290px"
              :close-on-content-click="false"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="form.date | moment('DD/MM/YYYY')"
                  readonly
                  hide-details
                  outlined
                  dense
                  v-on="on"
                >
                  <template v-slot:append>
                    <v-icon v-text="'fas fa-calendar-alt'"></v-icon>
                  </template>
                </v-text-field>
              </template>
              <v-date-picker
                v-model="form.date"
                no-title
                scrollable
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="6">
            <p class="label">Location</p>
            <v-text-field
              outlined
              hide-details="auto"
              v-model="form.location"
              required
              class="mb-4"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <p class="label">Time Start</p>
            <v-menu
              ref="menu"
              :close-on-content-click="false"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="form.timeStart"
                  readonly
                  hide-details
                  outlined
                  dense
                  v-on="on"
                ></v-text-field>
              </template>
              <v-time-picker
                v-model="form.timeStart"
                full-width
                :min="form.timeEnd"
              ></v-time-picker>
            </v-menu>
          </v-col>
          <v-col cols="6">
            <p class="label">Time End</p>
            <v-menu
              ref="menu"
              :close-on-content-click="false"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="form.timeEnd"
                  readonly
                  hide-details
                  outlined
                  dense
                  v-on="on"
                ></v-text-field>
              </template>
              <v-time-picker
                v-model="form.timeEnd"
                full-width
                :min="form.timeStart"
              ></v-time-picker> </v-menu
          ></v-col>
          <v-col cols="6">
            <p class="label">Activation</p>
            <v-checkbox v-model="form.active" class="mx-2"> </v-checkbox>
          </v-col>
          <v-col cols="12">
            <v-btn color="primary" @click="save" rounded depressed>Save</v-btn>
            <v-btn
              class="px-2 ml-3"
              color="gray"
              rounded
              depressed
              @click="cancel"
              >Cancel</v-btn
            >
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import salonService from "@/services/salon";
import { mapState } from "vuex";
export default {
  name: "SalonForm",
  props: {},
  data: () => ({
    file: null
  }),
  computed: {
    ...mapState({
      form: state => state.salon.salon
    })
  },
  methods: {
    clickInputUpload(event) {
      event.preventDefault();
      this.$refs.fileUpload.click();
    },
    setFile(files) {
      this.file = files[0];
      this.form.image = URL.createObjectURL(files[0]);
    },
    async uploadFile() {
      if (!this.file) return;

      let formData = new FormData();
      formData.append("file", this.file);

      const res = await salonService.uploadFile(formData);
      if (res) {
        this.form.image = res.data.url_file;
      }
    },
    cancel() {
      this.$store.dispatch("resetSalon");
      this.$router.push({
        name: "Salon"
      });
    },
    async save() {
      await this.uploadFile();
      if (this.form.id) {
        let res = await salonService.update(this.form);
        if (res) {
          this.$router.push({
            name: "Salon"
          });
        }
      } else {
        this.form.date = this.$moment(this.form.date).format("YYYY-MM-DD");
        let res = await salonService.create(this.form);
        if (res) {
          this.$router.push({
            name: "Salon"
          });
        }
      }
    }
  }
};
</script>

